import {
    AssetGroup,
    AssetGroupAssociationData,
    AssetGroupUpdateData,
} from '@app/shared/models/asset-group.model';
import { HttpClient } from '@angular/common/http';
import { AssetGroupAssociation } from '@core/utils/asset-group/asset-group-association';

export class CreateAGAssociation extends AssetGroupAssociation {
    action = 'POST';
    data: AssetGroupUpdateData;

    constructor(
        httpClient: HttpClient,
        assetGroup: AssetGroup,
        originalList: AssetGroup[],
        updatedList: AssetGroup[]
    ) {
        super(httpClient);
        this.data = this.getData(assetGroup, originalList, updatedList);
    }

    getAssociationPayload(): AssetGroupAssociationData {
        return {
            refAssetGroup: this.data.assetGroup.original.id,
            action: this.action,
            lineageFrom: [
                ...super.getAncestorsIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.original,
                    []
                ),
                ...super.getChildrenIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.original,
                    []
                ),
            ],
            lineageTo: [
                ...super.getAncestorsIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.updated,
                    []
                ),
                this.data.assetGroup.original.id,
                ...super.getChildrenIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.updated,
                    []
                ),
            ],
        };
    }
}
